<template>
   <div>
      <v-card>
         <v-card-title>Present Employment Category</v-card-title>
         <v-card-subtitle>(Please tick the appropriate check-boxes)</v-card-subtitle>
         <v-card-text>
            <v-row dense>
               <v-col cols="12" md="6" sm="6">
                  <v-checkbox v-model="form.ispvtsectoremp" label="Private Sector Employee" dense/>
               </v-col>
               <v-col cols="12" md="6" sm="6">
                  <v-checkbox v-model="form.isstatepublicsvc" label="State or Federal Public Services" dense/>
               </v-col>
               <v-col cols="12" md="6" sm="6">
                  <v-checkbox v-model="form.islocalgov" label="Local Government" dense/>
               </v-col>
               <v-col cols="12" md="6" sm="6">
                  <v-checkbox v-model="form.isselfemployed" label="Self Employment" dense/>
               </v-col>
               <v-col cols="12" md="6" sm="6">
                  <v-checkbox v-model="form.isacademic" label="Academic" dense/>
               </v-col>
               <v-col cols="12" md="6" sm="6">
                  <v-checkbox v-model="form.isretired" label="Retired" dense/>
               </v-col>
               <v-col cols="12" md="6" sm="6">
                  <v-checkbox v-model="form.isunemployed" label="Unemployed" dense/>
               </v-col>
               <v-col cols="12" md="6" sm="6">
                  <v-text-field label="Other" v-model="form.other"></v-text-field>
               </v-col>
            </v-row>
         </v-card-text>
      </v-card>
   </div>
</template>

<script>
const axios = require('axios')

export default {
   name: "TableEmpCat",

   data: () => ({
      userid: 0,
      isempty: true,
      form: {
         userid: 0,
         ispvtsectoremp: false,
         isstatepublicsvc: false,
         islocalgov: false,
         isselfemployed: false,
         isacademic: false,
         isretired: false,
         isunemployed: false,
         other: ""
      }
   }),

   methods: {
      setuserid(pUserID) {
         this.userid = pUserID
         this.initialize()
      },

      initialize() {
         this.$nextTick(() => {
            var targetPath = ''
            if (this.userid !== 0) {
               targetPath = '/member/empcat/list/' + this.userid // get id from property
            } else {
               targetPath = '/member/empcat/list' // get id from current login session (server-side)
            }
            axios.get('/member/empcat/list')
            .then((resp) => {
               if (resp.data) {
                  var rtn = resp.data
                  if (rtn.status === 'OK') {
                     if (rtn.data) {
                        this.form.ispvtsectoremp = rtn.data.ispvtsectoremp
                        this.form.isstatepublicsvc = rtn.data.isstatepublicsvc
                        this.form.islocalgov = rtn.data.islocalgov
                        this.form.isselfemployed = rtn.data.isselfemployed
                        this.form.isacademic = rtn.data.isacademic
                        this.form.isretired = rtn.data.isretired
                        this.form.isunemployed = rtn.data.isunemployed
                        this.form.other = rtn.data.other ? rtn.data.other : ""
                        this.isempty = false
                     }
                  } else {
                     console.log(rtn.status + ': ' + rtn.error)
                  }
               }
            })
         })
      },

      update() {
         var targetPath = ""
         var data = {
            userid: this.userid,
            ispvtsectoremp: this.form.ispvtsectoremp,
            isstatepublicsvc: this.form.isstatepublicsvc,
            islocalgov: this.form.islocalgov,
            isselfemployed: this.form.isselfemployed,
            isacademic: this.form.isacademic,
            isretired: this.form.isretired,
            isunemployed: this.form.isunemployed,
            other: this.form.other
         }
         if (this.isempty) {
            targetPath = "/member/empcat/add"
         } else {
            targetPath = "/member/empcat/update"
         }
         axios.post(targetPath, data)
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.$emit('EmpCatUpdated')
                  this.initialize()
               } else {
                  console.log(rtn.status + ': ' + rtn.error)
               }
            }
         })
      }
   },

   mounted: function () {
      this.$emit('EmpCatMounted')
   }
}
</script>
